module.exports = __webpack_public_path__ + "img/018.0ce59bd3.png";